/**
 * Slug utility for generating SEO-friendly URLs.
 *
 * Podcaster: "michael-junior-soler-d22060c2" (name + first 8 chars of UUID)
 * Blog:      "how-to-find-the-perfect-podcast-guest" (title only)
 */

function slugify(text) {
  return (text || '')
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')   // remove non-word chars
    .replace(/[\s_]+/g, '-')    // spaces/underscores → hyphens
    .replace(/-+/g, '-')        // collapse multiple hyphens
    .replace(/^-+|-+$/g, '');   // trim leading/trailing hyphens
}

/** Generate a profile slug: "first-last-name-abcd1234" */
export function toProfileSlug(name, id) {
  const nameSlug = slugify(name);
  const shortId = String(id || '').substring(0, 8);
  return nameSlug ? `${nameSlug}-${shortId}` : shortId;
}

/** Extract the 8-char short ID from the end of a profile slug */
export function fromProfileSlug(slug) {
  if (!slug) return slug;
  // If it's already a full UUID, return as-is
  if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(slug)) {
    return slug;
  }
  // Extract last 8 hex chars
  const parts = slug.split('-');
  const lastPart = parts[parts.length - 1];
  if (/^[0-9a-f]{8}$/i.test(lastPart)) {
    return lastPart;
  }
  return slug;
}

/** Generate a blog slug from the title: "how-to-find-the-perfect-guest" */
export function toBlogSlug(title) {
  return slugify(title);
}

export { slugify };
